<template>
  <v-img src="../../../../static/img/background.png" contain>
    <v-container fluid>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :top="true"
        :right="true"
        :timeout="-1"
        absolute
      >
        {{ message }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </v-snackbar>
      <v-row>
        <v-progress-circular v-show="approveloading || declineloading" color="secondary"
                class="accent--text logoutbtn" size="25"
                             indeterminate></v-progress-circular>
        <v-spacer></v-spacer>

        <v-row no-gutters justify="space-around" class="mb-4 mt-4">
            <v-col  v-if="canUploadCatalogue" class="d-flex justify-center">
              <v-btn color="#3386FF" @click="downloadSweepingsFileDialog" class="white--text parchmentbtn">Sweepings
                Template
              </v-btn>
            </v-col>

            <v-col  v-if="canUploadCatalogue" class="d-flex justify-center">
              <!-- <v-btn color="#7BC243" @click="uploadParchmentDialog" class="white--text parchmentbtn">Upload Sweepings -->
              <v-btn color="#7BC243" @click="termsDialog" class="white--text parchmentbtn">Upload Sweepings
              </v-btn>
            </v-col>

          </v-row>

      </v-row>

      <v-layout>
        <v-flex xs12>
          <div :class="paginatedFiles.length === 7 ? 'parchment_box' : 'parchment_box_empty'">
            <v-card-text>
              <v-layout>
                <v-flex xs3>
                  <span class="accent--text" style="font-size: 14px; font-weight:700;"> Uploaded Sweepings </span>
                </v-flex>
                <v-spacer>
                </v-spacer>

                <v-flex xs3>
                   <v-text-field label="Search" v-model="search">
                  </v-text-field>
                </v-flex>

              </v-layout>
			    <v-progress-linear
    v-if="loading"
    indeterminate
    color="primary"
    height="4"
  ></v-progress-linear>

              <table class="table">

                <thead class="thead">
                <tr>
                  <th scope="col">File Name</th>
                  <th scope="col">Sale</th>
                  <th scope="col">Lots</th>
                  <th scope="col">Bags</th>
                  <th scope="col">Weight</th>
                  <th scope="col">Uploaded By</th>
                  <th scope="col">Status</th>
                  <th scope="col">Date</th>
                  <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="file in filteredList" v-bind:key="file.id">
                  <td>{{ file.fileName }}</td>
                  <td>{{ file.saleNumber }}</td>
                  <td>{{ file.numberOfLots }}</td>
                  <td>{{ file.totalBags }}</td>
                  <td>{{ file.totalWeight }}</td>
                  <td>{{ file.createdBy }}</td>
                  <!-- <td>{{ file.status.statusName }}</td> -->
				  <td :class="{
             'text-danger font-size-12 ': `${file.status.statusName}` === 'FAILED_VALIDATION',
              'text-warning font-size-12 ': `${file.status.statusName}` === 'FAILED_VALIDATION' }">
              {{ file.status.statusName }}
            </td>
                  <td>{{ file.dateCreated | prettyDate }}</td>
                  <td class="actions">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          v-on="on"
                          text
                          icon
                          
                        >
                          <v-icon small> more_horiz</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-if="file.status.id !==58 " v-bind:to="'/sweeping/' +  file.id  + '/checkoffSettlementDetails'">
                          <v-list-item-title> View</v-list-item-title>
                        </v-list-item>
                        <v-list-item  v-if="file.status.id ===1" @click="confirmDropFileAction(file, 'delete')">
                          <v-list-item-title> Drop File</v-list-item-title>
                        </v-list-item>
                        <v-list-item  v-if="file.status.id ===64" @click="confirmDropFileAction(file, 'approve')">
                          <v-list-item-title> Approve DeletionFile</v-list-item-title>
                        </v-list-item>
                        <v-list-item  v-if="file.status.id ===64" @click="confirmDropFileAction(file, 'decline')">
                          <v-list-item-title> Reject DeletionFile</v-list-item-title>
                        </v-list-item>
                        <v-list-item  v-if="file.status.id ===1 || file.status.id ===58 " v-bind:to="'/parchment/' +  file.id  + '/deleted'">
                          <v-list-item-title> View Deleted</v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="canBeApproved(file)" @click="confirmAction(file, 'approve')">
                          <v-list-item-title> Approve</v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="canBeDeclined(file)" @click="confirmAction(file, 'decline')">
                          <v-list-item-title> Decline</v-list-item-title>
                        </v-list-item>
						<v-list-item v-if="canBeDownloaded(file)" @click="downloadUploadedSweepingsFile(file)">
                          <v-list-item-title> Download </v-list-item-title>
                        </v-list-item>
						<v-list-item v-if="hasErrorFile(file)" @click="downloadErrorFile(file)">
						  <v-list-item-title class="text-danger font-size-12">Download Error File</v-list-item-title>

                        </v-list-item>

                      </v-list>
                    </v-menu>
                  </td>
                </tr>
                </tbody>
              </table>
            </v-card-text>
            <v-card-actions>
              <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
              <v-spacer></v-spacer>
              <v-pagination
                v-model="page"
                :length="numberOfLinks"
                :total-visible="7"
                color="secondary"
                class="accent--text logoutbtn"
              ></v-pagination>
            </v-card-actions>
          </div>
        </v-flex>
        <v-dialog v-model="confirmDialog" max-width="400">
          <v-card>
            <v-card-title class="body-2 primary--text font-weight-bold text-capitalize">{{ this.action }} Sweepings
            </v-card-title>

            <v-card-text class="primary--text">
              {{ confirmMessage }}
              <v-text-field
                name="comment"
                label="Comment"
                v-model="confirmFile.approverComment"
                :rules="commentRules"
                required>
              </v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="confirmDialog = false"
                class="font-weight-bold"
              >
                Cancel
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                class="accent--text logoutbtn"
                @click="approveOrDecline(confirmFile)"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="confirmDeleteDialog" max-width="400">
          <v-card>
            <v-card-title class="body-2 primary--text font-weight-bold text-capitalize">{{ this.action }} Sweepings
            </v-card-title>

            <v-card-text class="primary--text">
              {{ confirmMessage }}
              <v-text-field
                name="comment"
                label="Comment"
                v-model="confirmFile.approverComment"
                :rules="commentRules"
                required>
              </v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="confirmDeleteDialog = false"
                class="font-weight-bold"
              >
                Cancel
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                class="accent--text logoutbtn"
                @click="deleteFile(confirmFile)"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="uploadFileDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline accent--text">Upload Sweepings</v-card-title>
            <v-card-subtitle v-if="isUploadDisabled" class="accent--text" style="color: darkred !important;">Kindly note that the Sweepings File should be uploaded 12 days before the reference sale date below</v-card-subtitle>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
				<v-col  class="accent--text" style="font-size: 14px; font-weight:700;">   <div>{{ days }} Days {{ hours }} Hrs {{ minutes }} Mins {{ seconds }} Seconds</div> Remaining for Sale No. {{ saleNo }} Sale Date {{ saleDate }}</v-col>
                <label>File
                  <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" required/>
                </label>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="uploadFileDialog = false">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="secondary"
                class="accent--text logoutbtn" @click="uploadParchment">Upload</v-btn>
			  <v-progress-circular v-show="uploadLoading" color="red" size="20" indeterminate ></v-progress-circular>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="termsAndCoditionDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline accent--text">Terms and Conditions</v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <label>I hereby confirm that the data provided is authentic and dependable, and can be utilized by DSS to process payments.
                </label>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="termsAndCoditionDialog = false">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="secondary"
                class="accent--text logoutbtn" @click="uploadParchmentDialog">Agree</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="downloadFileDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline accent--text">Sweepings File</v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <div class="form-group">
                  <label class="control-label" for="saleNo">Sale No.</label>
                  <input id="saleNo" ref="saleNo" class="form-control" type="text" placeholder="Sale No." required>
                </div>

                <div class="form-group">
                  <label class="control-label" for="season">Season</label>
                  <input id="season" ref="season" class="form-control" type="text" placeholder="Season" required>
                </div>
                <div class="form-group">
                  <label class="control-label" for="date">Date</label>
                  <input id="date" ref="date" class="form-control" type="date" placeholder="date" required>
                </div>
              </v-form>

            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="downloadFileDialog = false">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="secondary"
                class="accent--text logoutbtn" @click="downloadSweepingsFile">Get File</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-img>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import { Common } from '@/components/views/file/common'

export default {
	name: 'parchmentupload',
	data: function () {
		return {
			loading: false, // controls the progress bar visibilit
			previewItems: [],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			totalFiles: 0,
			pagination: { sortBy: 'id', descending: true },
			loading: false,
			search: '',
			expand: false,
			timerContent: true,
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: window.innerHeight <= 600 ? 6 : window.innerHeight > 600 && window.innerHeight <= 1000 ? 14 : 20,
			page: 1,
			currentPage: 0,

			confirmDialog: false,
			confirmDeleteDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			uploadFileDialog: false,
			termsAndCoditionDialog: false,
			downloadFileDialog: false,
			remainingTime: 0,
			interval: null,
			targetDate: '',
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			saleNo: '',
			saleDate: '',
			isUploadDisabled: false,
			commentRules: [
				v => !!v || 'Comment is required'
			],
			uploadLoading: false
		}
	},
	mounted () {
		this.getUploadedFiles(this.currentPage)
		this.permissions = store.state.user.roleId.permissions
		this.startCountdown()
		this.getUpcomingDate()
	},
	beforeDestroy () {
		clearInterval(this.interval)
	},
	watch: {
		files () {
			this.paginatedFiles = this.files

		},
		page: function (val) {
			this.paginatedFiles = this.getUploadedFiles(val - 1)
			// this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		formattedTime () {
			const minutes = Math.floor(this.time / 60)
			const seconds = this.time % 60
			return `${this.pad(minutes)}:${this.pad(seconds)}`
		},
		canUploadCatalogue: function () {
			return this.hasPerm('CAN_UPLOAD_CATALOGUE')
		},
		canApproveParchment: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => {
					const searchTerm = this.search.toLowerCase()
					var dateCreated = new Date(file.created)
					return (
						(file.fileName.toLowerCase().includes(searchTerm)) ||
            file.totalBags.toString().includes(searchTerm) ||
            file.totalWeight.toString().includes(searchTerm) ||
            file.status.statusName.toLowerCase().includes(searchTerm) ||
            file.createdBy.toLowerCase().includes(searchTerm) ||
            dateCreated.toDateString().toLowerCase().includes(searchTerm)
					)
				})
				// return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		}
	},
	methods: {
		startCountdown () {
			this.interval = setInterval(this.updateCountdown, 1000)
		},
		updateCountdown () {
			const now = new Date().getTime()
			const distance = this.targetDate - now
			if (distance < 0) {
				clearInterval(this.interval)
				this.isUploadDisabled = true
				this.days = 0
				this.hours = 0
				this.minutes = 0
				this.seconds = 0

				return
			}

			  this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
			  this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
			this.seconds = Math.floor((distance % (1000 * 60)) / 1000)
		},
		getUpcomingDate () {
			const fileType = 'PARCHMENT'
			const token = localStorage.getItem('token')
			const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
			const upcomingDate = config.serverURI + '/timer/upcomingdatewh/' + fileType
			const request = axios.get(upcomingDate, { tokenconfig })
			axios
				.all([request])
				.then(
					axios.spread((...responses) => {
						const response = responses[0]
						this.remainingTime = response.data.timeInMillis
						this.saleNo = response.data.saleNo
						this.saleDate = response.data.saleDate
						// if (this.remainingTime === 0) {
						// 	this.targetDate = 'empty'
						// 	console.log('zero22')
						// 	clearInterval(this.interval)
						// 	this.isUploadDisabled = true
						// 	this.timerContent = true
						// 	//$('#timer').css('display', 'none')
						// } else {
						// 	this.targetDate = this.remainingTime // new Date().getTime() + parseInt(this.remainingTime) * 60 * 1000
						// }
						this.targetDate = this.remainingTime
						// this.remainingTime = response.data
						// this.targetDate = new Date().getTime() + parseInt(this.remainingTime) * 24 * 60 * 60 * 1000
						// this.targetDate = new Date().getTime() + parseInt(this.remainingTime) * 60 * 1000
					})
				)
				.catch((errors) => {
					console.log(errors)
				})
		},
		confirmAction (item, action) {
			this.confirmFile = item
			this.confirmDialog = true
			this.action = action
			if (action === 'approve') {
				this.confirmMessage = 'Approve Sweepings ' + item.fileName + ' ?'
			} else if (action === 'decline') {
				this.confirmMessage = 'Decline Sweepings ' + item.fileName + ' ?'
			} else {
				console.error(action + 'Action not supported')
			}
		},
		confirmDropFileAction (item, action) {
			this.confirmFile = item
			this.confirmDeleteDialog = true
			this.action = action
			if (action === 'delete') {
				this.confirmMessage = 'Delete Sweepings ' + item.fileName + ' ?' + '.This Action is irreversible'
			} else if (action === 'approve') {
				this.confirmMessage = 'Approve Deletion of Sweepings ' + item.fileName + ' ?'
			} else if (action === 'decline') {
				this.confirmMessage = 'Reject Deletion of Sweepings ' + item.fileName + ' ?'
			} else {
				console.error(action + 'Action not supported')
			}
		},
		canBeApproved (item) {
			return (item.status.id === 3 || item.status.id === 0) && this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		canBeDownloaded (item) {
			return item.status.id !== 87 && item.status.id !== 88
		},
		hasErrorFile (item) {
			return item.status.id === 88
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		approveOrDecline (item) {
			if (this.action === 'approve') {
				this.approve(item)
			} else if (this.action === 'decline') {
				this.decline(item)
			} else {
				console.error('Function not supported')
			}
		},
		deleteFile (item) {
			console.log('Action>>>', this.action)
			if (this.action === 'delete') {
				this.markAsdeleted(item)
			} else if (this.action === 'approve') {
				this.approveRejectdeletion(item)
			} else if (this.action === 'decline') {
				this.rejectdeletion(item)
			} else {
				console.error('Function not supported')
			}
		},
		approve (item) {
			this.approveloading = true
			const url = config.serverURI + '/upload/sweepings/approve'
			console.log(item)
			axios.post(url, item)
				.then(response => {
					this.approveloading = false
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						return
					}
					this.getUploadedFiles(this.currentPage)
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveloading = false
				})
			this.confirmDialog = false
		},
		markAsdeleted (item) {
			this.approveloading = true
			const url = config.serverURI + '/upload/parchment/delete-parchment'
			console.log(item)

			axios.post(url, item)
				.then(response => {
					this.confirmDeleteDialog = false
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						return
					}
					this.getUploadedFiles(this.currentPage)
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveloading = false
				})
			this.confirmDeleteDialog = false
		},
		approveRejectdeletion (item) {
			this.approveloading = true
			const url = config.serverURI + '/upload/parchment/approve-delete-parchment'
			console.log(item)

			axios.post(url, item)
				.then(response => {
					this.confirmDeleteDialog = false
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						return
					}
					this.getUploadedFiles(this.currentPage)
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveloading = false
				})
			this.confirmDeleteDialog = false
		},
		rejectdeletion (item) {
			this.approveloading = true
			const url = config.serverURI + '/upload/parchment/reject-delete-parchment'
			console.log(item)

			axios.post(url, item)
				.then(response => {
					this.confirmDeleteDialog = false
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						return
					}
					this.getUploadedFiles(this.currentPage)
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveloading = false
				})
			this.confirmDeleteDialog = false
		},
		decline (item) {
			this.declineloading = true
			const url = config.serverURI + '/upload/parchment/decline'
			axios.post(url, item)
				.then(response => {
					this.declineloading = false
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.getUploadedFiles(this.currentPage)
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			this.confirmDialog = false
		},
		getUploadedFiles (page) {
			var url = config.serverURI + '/upload/sweepings/all?page=' + page + '&size=' + this.numberOfItemsPerPage + '&paginate=Y'
			this.loading = true; // Show progress bar
			axios.get(url)
				.then(response => {
					this.loading = false; // Show progress bar
					this.files = response.data.content
					this.numberOfLinks = response.data.page.totalPages
					this.numberOfItemsPerPage = response.data.page.size
					this.currentPage = response.data.page.number
				})
				.catch(error => {
					this.loading = false; // Hide progress bar
					// Request failed.
					console.log('error', error.response)
				})
			return this.files
		},
		uploadParchmentDialog () {
			this.termsAndCoditionDialog = false
			this.uploadFileDialog = true

			// if (this.isUploadDisabled){
			//   this.snackbar = true
			//   this.snackbarColor = 'error'
			//   this.message = 'Your timeline for file upload has elapsed'
			// }
		},
		termsDialog () {
			this.termsAndCoditionDialog = true
		},
		downloadParchmentDialog () {
			this.downloadFileDialog = true
		},
		uploadParchment () {
			if (this.$refs.form.validate()) {
				if (!this.file) {
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = 'Please select a file before uploading.'
					return
				}

				const reader = new FileReader()
				reader.readAsDataURL(this.file) // Convert file to Base64

				reader.onload = () => {
					const base64String = reader.result.split(',')[1] // Remove the "data:mime/type;base64," prefix

					const payload = {
						fileName: this.file.name,
						fileType: this.file.type,
						fileData: base64String
					}

					const url = config.serverURI + '/upload/sweepings/file'
					this.uploadLoading = true

					axios.post(url, payload)
						.then(response => {
							this.uploadLoading = false
							this.uploadFileDialog = false
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.message = 'Success'

							this.getUploadedFiles(0)
						})
						.catch(error => {
							this.uploadLoading = false
							if (error.response) {
								Common.blobToJson(error.response.data)
									.then(jsonData => {
										this.message = jsonData.message || `${error.response.status} Request failed`
									})
									.catch(() => {
										this.message = error.response.data?.message || `${error.response.status}: Error occurred`
									})
							} else {
								this.message = 'Network error or server unreachable'
							}

							this.snackbar = true
							this.snackbarColor = 'error'
							this.uploadFileDialog = false
						})
				}

				reader.onerror = () => {
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = 'Error reading file. Please try again.'
				}
			}
		},

    downloadSweepingsFileDialog(){
      this.downloadFileDialog = true
    },
		downloadSweepingsFile () {
			const url = config.serverURI + '/files/downloads?filename=sweepings&season=' + this.$refs.season.value +
			 '&saleNo=' + this.$refs.saleNo.value + '&date=' + this.$refs.date.value
			// const url = config.serverURI + '/files/downloads?filename=sweepings&season=2023/2024&saleNo=33&date=12-04-2025'

			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					this.downloadFileDialog = false

					// console.log(response)

					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
					const link = document.createElement('a')
					link.href = url
					// const itemFileName = 'parchment_' + this.$refs.saleNo.value + '_' + this.$refs.season.value?.replace(/\//g, '_') + '.xlsx'
					const itemFileName = 'sweepings_template.xlsx'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()

					this.message = response.message
					this.snackbar = true
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					console.log('error', error.response)
					// this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					Common.blobToJson(error.response.data)
						.then(jsonData => {
							this.message = typeof jsonData.message !== 'undefined' ? jsonData.message : error.response.status + ' Request failed'
						})
						.catch(error => {
							console.error('Error:', error)
							this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status + ': Error occurred'
						})
					this.snackbar = true
					this.snackbarColor = 'error'
					this.downloadFileDialog = false
				})
			this.handleFileUpload()
		},

		downloadUploadedSweepingsFile (item) {
			const url = config.serverURI + '/upload/sweepings/download/' + item.id
			axios({ url: url, method: 'POST', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.fileName ? item.fileName : 'sweepings_file.xlsx'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		downloadErrorFile (item) {
			const url = config.serverURI + '/upload/parchment/download-error/' + item.id
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = 'File_With_Errors_' + item.fileName
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},

		pad (value) {
			return String(value).padStart(2, '0')
		},
		startTimer () {
			this.time = 300 // Example: 5 minutes countdown
			if (this.interval) {
				clearInterval(this.interval)
			}
			this.interval = setInterval(() => {
				if (this.time > 0) {
					this.time--
				} else {
					clearInterval(this.interval)
				}
			}, 1000)
		}
	},
	beforeDestroy () {
		if (this.interval) {
			clearInterval(this.interval)
		}
	}

}

</script>
<style>
.parchment_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.parchment_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.parchment_box:after, .parchment_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.parchment_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.parchment_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}
</style>
